"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = payments;

var _merge = require("lodash/merge");

var _merge2 = _interopRequireDefault(_merge);

var _actionTypes = require("../actions/actionTypes");

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Payments reducer stores data through the payment lifecycle: selecting plan, saving card,
 * prorating subscription charges.
 *
 *
 */

if (!global._babelPolyfill) {
    require('babel-polyfill');
};
function payments() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        availablePlans: [],
        selectedPlan: null,
        chargePreview: {},
        stripeToken: null
    };
    var action = arguments[1];

    switch (action.type) {
        case actionTypes.FETCH_SPACE_PLANS_SUCCESS:
            {
                return (0, _merge2.default)({}, state, { availablePlans: action.response.plans });
            }
        case actionTypes.SELECT_SPACE_PLAN:
            {
                return (0, _merge2.default)({}, state, { selectedPlan: action.plan });
            }
        case actionTypes.FETCH_CHARGE_PREVIEW:
            {
                return (0, _merge2.default)({}, state, { chargePreview: null });
            }
        case actionTypes.FETCH_CHARGE_PREVIEW_SUCCESS:
            {
                return (0, _merge2.default)({}, state, {
                    chargePreview: action.response.charge_preview
                });
            }
        case actionTypes.CREATE_STRIPE_TOKEN_SUCCESS:
            {
                return (0, _merge2.default)({}, state, { stripeToken: action.token });
            }
        case actionTypes.CREATE_STRIPE_TOKEN_FAILURE:
        case actionTypes.REPLACE_CREDIT_CARD_SUCCESS:
        case actionTypes.REPLACE_CREDIT_CARD_FAILURE:
        case actionTypes.CHANGE_SUBSCRIPTION_SUCCESS:
        case actionTypes.CHANGE_SUBSCRIPTION_FAILURE:
            {
                return (0, _merge2.default)({}, state, { stripeToken: null });
            }
        default:
            return state;
    }
}